/* eslint-disable no-console */
import { AnalyticsProvider, IdentityPayload, TrackProps } from '../manager';
import { Intercom, update, trackEvent } from '@intercom/messenger-js-sdk';
import moment from 'moment-timezone';

export class IntercomProvider implements AnalyticsProvider {
  public intercom: Function | null | undefined = null;
  private isInitialized = false;
  private appId: string = '';

  public init(options: { appId: string; debug?: boolean }): void {
    try {
      if (!options.appId) {
        console.debug('Intercom: No app ID provided, skipping initialization');
        return;
      }

      this.appId = options.appId;

      // Intercom may already be initialized by another plugin (auth/intercom.ts)
      if (!window.Intercom) Intercom({ app_id: this.appId });

      this.intercom = window.Intercom;
      this.isInitialized = true;
      if (options.debug) console.debug('Intercom initialized successfully');
    } catch (error) {
      console.debug('Failed to initialize Intercom:', error);
    }
  }

  public identify(identity: IdentityPayload): void {
    if (!this.isReady()) return;

    try {
      update({
        user_id: identity.userId,
        email: identity.email,
        name: `${identity.firstName === null ? '' : identity.firstName + ' '}${identity.lastName ?? ''}`,
        last_request_at: moment().unix(), // trigger a `ping` request automatically
        ...identity.properties,
      });
    } catch (error) {
      console.debug('Intercom identify failed:', error);
    }
  }

  public track(event: string, properties?: TrackProps): void {
    if (!this.isReady()) return;

    try {
      trackEvent(event, { ...properties });
    } catch (error) {
      console.debug('Intercom track failed:', error);
    }
  }

  public isReady(): boolean {
    return this.isInitialized && !!this.intercom;
  }

  public startSessionRecording(): void {
    // No-op: Session recording is not needed for Intercom
  }

  public stopSessionRecording(): void {
    // No-op: Session recording is not needed for Intercom
  }
}
